<template>
    <DashView>
        <div class="container-fluid pt-4 px-4">
            <div class="row g-4">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <h3><a href="/user-register"><i class="fa fa-plus-square"></i></a>&nbsp;Utilisateur <span class="badge bgbadge">{{users.length}}</span> </h3>
                            <div class="table-responsive mb-5">
                                <template v-if="users.length>0">
                                    <div class="table-wrapper">
                                        <table class="table table-striped table-bordered mb-5">
                                        <thead>
                                            <tr>
                                                <th>Utilisateurs</th>
                                                <th>Titre</th>
                                                <th>Email</th>
                                                <th>Téléphone</th>
                                                <!-- <th>Sexe</th>
                                                <th>Inscription</th> -->
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(user,key) in users" :key="key">
                                                <td>{{user.nom}} {{user.prenom}}</td>
                                                <td>{{user.role}}</td>
                                                <td>{{user.mail}}</td>
                                                <td>{{user.telephone}}</td>
                                                <!-- <td>{{ user.sexe_user === 1 ? 'Masculin' : 'Feminin' }}</td>
                                                <td>{{ formatDate(user.date_creation)}}</td> -->
                                                <td>
                                                    <a href="#" class="text-inverse pr-2" @click="getInfoUser(user.id)"  title="Details" data-bs-toggle="modal" data-bs-target="#voirdetails"><i class="fa fa-eye"></i></a>&nbsp;&nbsp;
                                                    <a href="#" class="text-inverse pr-2" @click="editInfoUser(user.id)" title="Edit" data-bs-toggle="modal" data-bs-target="#myModalUpdateUser"><i class="fa fa-edit"></i></a>
                                                    <a href="#" class="text-inverse pr-2" @click="resetUser(user.id)" title="Reset Password" data-bs-toggle="modal" data-bs-target="#myModalResetPassword"><span class="fa-passwd-reset fa-stack"><i class="fa fa-undo fa-stack-1x"></i><i class="fa fa-lock fa-stack-1x"></i></span></a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                    
                                </template>
                                <template v-else>
                                    <div class="modal-preloader">
                                        <div class="spinner"></div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </DashView>
    <!-- START All Modal -->
        <!--Begin voirdetails -->
        <div class="modal" id="voirdetails">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h5 class="modal-title text-center" id="exampleModalLabel">Détails Utilisateur</h5>
                        <button type="button" id="closeVoirDetailsUser" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body">
                       <template v-if="info_user?.utilisateur">
                        <div class="col-lg-12 text-center">
                            <div class="card mb-4">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <p class="mb-0">Nom</p>
                                        </div>
                                        <div class="col-sm-8">
                                            <p class="text-muted mb-0">{{ info_user.nom_user }}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <p class="mb-0">Prénom</p>
                                        </div>
                                        <div class="col-sm-8">
                                            <p class="text-muted mb-0">{{ info_user.prenom_user }}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row" v-if="info_user.specialites">
                                        <div class="col-sm-4">
                                            <p class="mb-0">Spécialités</p>
                                        </div>
                                        <div class="col-sm-8">
                                            <p class="text-muted mb-0">{{ info_user.specialites.map(s => s.specialite).join(', ') }}</p>
                                        </div>
                                        <hr>
                                    </div>
                                    <div class="row" v-if="info_user.services && info_user.services.length > 0">
                                    <div class="col-sm-4">
                                        <p class="mb-0">Services</p>
                                    </div>
                                    <div class="col-sm-8 ">
                                        <p class="text-muted mb-0 font-italic" v-for="(service, index) in info_user.services" :key="index">
                                        {{ service.service }} {{ service.specialite }} - {{ service.prix }} G
                                        </p>
                                    </div>
                                    </div>
                                    <hr>

                                    <div class="row">
                                    <div class="col-sm-4">
                                        <p class="mb-0">Email</p>
                                    </div>
                                    <div class="col-sm-8">
                                        <p class="text-muted mb-0">{{ info_user.email_user }}</p>
                                    </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                    <div class="col-sm-4">
                                        <p class="mb-0">Téléphone</p>
                                    </div>
                                    <div class="col-sm-8">
                                        <p class="text-muted mb-0">{{ info_user.phone_user }}</p>
                                    </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <p class="mb-0">Sexe</p>
                                        </div>
                                        <div class="col-sm-8">
                                            <p class="text-muted mb-0">{{info_user.sexe_user === 1 ? 'Masculin' : 'Féminin' }}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <p class="mb-0">Rôle</p>
                                        </div>
                                        <div class="col-sm-8">
                                            <p class="text-muted mb-0">{{ info_user.role_user }}</p>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <p class="mb-0">Date création</p>
                                        </div>
                                        <div class="col-sm-8">
                                            <p class="text-muted mb-0">{{ formatDate(info_user.date_creation) }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                       </template>
                       <template v-else>
                        <!-- <p class="text-center">Loading...</p> -->
                        <div class="modal-preloader">
                            <div class="spinner"></div>
                        </div>
                    </template>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" id="closeModalou" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                    </div>

                    </div>
                </div>
            </div>
        <!--End voirdetails -->

        <!-- Start Modal Update User -->
            <!-- The Modal Update User-->
            <div class="modal" id="myModalUpdateUser">
                <div class="modal-dialog">
                    <div class="modal-content">             
                        <!-- Modal Header -->
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Modifié Utilisateur</h5>
                            <button type="button" id="closeModifierUser" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        
                        <!-- Modal body -->
                        <div class="modal-body">
                            <p v-if="success_msg" class="text-white alert text-center" style="background: #00C853;">{{ success_msg }}</p>
                            <template v-if="editUser?.utilisateur">
                                <div class="col-lg-12">
                                    <div class="card mb-4">
                                        <div class="card-body">
                                            <div class="row" v-if="validationErrors.length>0">
                                                <div class="offset-2 col-md-8 col-sm-12 alert alert-danger alert-md text-danger mx-auto">
                                                    <ul v-if="validationErrors.length>0" class="list-unstyled text-center mx-auto">
                                                        <li v-for="(error,key) in validationErrors" :key="key" class="p-2"><div class="">{{error}}</div></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <p class="mb-0">Nom</p>
                                                </div>
                                                <div class="col-sm-8">
                                                    <input type="text" v-model="form_update.nom" class="form-control">
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <p class="mb-0">Prénom</p>
                                                </div>
                                                <div class="col-sm-8">
                                                    <input type="text" v-model="form_update.prenom" class="form-control">
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <p class="mb-0">Email</p>
                                                </div>
                                                <div class="col-sm-8">
                                                    <input type="text" v-model="form_update.email" class="form-control">
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="row">
                                            <div class="col-sm-4">
                                                <p class="mb-0">Téléphone</p>
                                            </div>
                                            <div class="col-sm-8">
                                                <input type="text" v-model="form_update.phone" class="form-control">
                                            </div>
                                            </div>
                                            <hr>
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <p class="mb-0">Rôle</p>
                                                </div>
                                                <div class="col-sm-8">
                                                    <p class="text-muted mb-0">{{ editUser.role_user }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <!-- <p class="text-center">Loading...</p> -->
                                <div class="modal-preloader">
                                    <div class="spinner"></div>
                                </div>
                            </template>
                        </div>
                        
                        <!-- Modal footer -->
                        <div class="modal-footer d-flex justify-content-between">
                            <button type="button" :disabled="form_update.nom =='' || form_update.prenom=='' || form_update.email=='' || form_update.phone==''" class="btn float-left" style="background-color: #00C853; color: #fff;" @click="updateUser">Enrégistrer</button>
                            <button type="button" id="closeModalUpdated" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                        </div>
                        
                    </div>
                </div>
            </div>
        <!-- End Modal Update User -->

        <!-- Start Modal Reset Password -->
            <!-- The Modal -->
            <div class="modal" id="myModalResetPassword">
                <div class="modal-dialog">
                    <div class="modal-content">

                        <!-- Modal Header -->
                        <div class="modal-header">
                            <h4 class="modal-title">Réinitialiser mot-de-passe</h4>
                            <button type="button" id="closeResetPasswordUser" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>

                        <!-- Modal body -->
                        <div class="modal-body">
                            <template v-if="resetpUser?.utilisateur">
                                <div class="container">
                                    <div class="row">
                                            <div class="col-md-4 col-sm-6 col-xs-6">
                                                <p class="mb-0">Nom</p>
                                            </div>
                                            <div class="col-md-8 col-sm-6 col-xs-6">
                                                <p class="text-muted mb-0">{{ resetpUser.nom_user }}</p>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="row">
                                            <div class="col-sm-4">
                                                <p class="mb-0">Prénom</p>
                                            </div>
                                            <div class="col-sm-8">
                                                <p class="text-muted mb-0">{{ resetpUser.prenom_user }}</p>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="row">
                                        <div class="col-sm-4">
                                            <p class="mb-0">Email</p>
                                        </div>
                                        <div class="col-sm-8">
                                            <p class="text-muted mb-0">{{ resetpUser.email_user }}</p>
                                        </div>
                                        </div>
                                        <hr>
                                        <div class="row">
                                        <div class="col-sm-4">
                                            <p class="mb-0">Téléphone</p>
                                        </div>
                                        <div class="col-sm-8">
                                            <p class="text-muted mb-0">{{ resetpUser.phone_user }}</p>
                                        </div>
                                        </div>
                                        <hr>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="panel panel-default">
                                            <div class="panel-body">
                                                <div class="text-center">
                                                <h3>
                                                    <span class="fa-passwd-resets fa-stack"><i class="fa fa-undo fa-stack-1x"></i><i class="fa fa-lock fa-stack-1x"></i></span>
                                                </h3>
                                                <p>Tu peux réinitialiser son mot de passe ici👇.</p>
                                                <div class="panel-body">                                
                                                    <form id="register-form" role="form" autocomplete="off" class="form">
                                                        <div class="form-group">
                                                            <div class="input-group">
                                                                <input class="form-control text-center" type="text" v-model="passwordReset" id="pass" placeholder="Cliquer sur le bouton Generer mot de passe">
                                                            </div>
                                                        </div>
                                                        <div class="form-group p-2" v-if="passwordReset">
                                                            <button class="btn btn-primary re w-100" style="background-color: #00C853; border-color: transparent;" type="button" @click="textCopy">
                                                                    <i class="fa fa-copy" style="color: #fff;"></i>&nbsp; Copié mot de passe</button>
                                                        </div>                           
                                                        <div class="form-group p-2">
                                                            <input @click="resetPassword(resetpUser.email_user)" class="btn text-white d-block w-100" style="background-color: #00C853; border-color: aliceblue;" value="Générer Mot de passe" type="button">
                                                        </div>  
                                                        <div id="toast">Mot de passe Copié !</div>                      
                                                                                                        
                                                    </form>
                                    
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                           </template>
                            <template v-else>
                                <!-- <p class="text-center">Loading...</p> -->
                                <div class="modal-preloader">
                                    <div class="spinner"></div>
                                </div>
                            </template>
                        </div>

                        <!-- Modal footer -->
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                        </div>

                    </div>
                </div>
            </div>
        <!-- End Modal Reset Password -->
    <!-- ENd All Modal -->
</template>
<script>
import DashView from "@/components/DashView.vue"
import axios from 'axios'
import $ from 'jquery';
const base_url=process.env.VUE_APP_API_URL;
export default {
    name:"UserAll",
    components:{
        DashView
    },
    data(){
        return{          
          users:[],
          passwordReset:'',
          info_user:[],
          editUser:[],
          resetpUser:[],
          form_update:{
            nom:'',
            prenom:'',
            email:'',
            phone:'',
            user:''
          },
          success_msg:'',
          validationErrors:[],
          accessToken:JSON.parse(localStorage.getItem('user_zgh')).token ?? '',
        }
    },
    created(){
        // (JSON.parse(localStorage.getItem('user_zgc')).code_role)>3 ? this.$router.push('all-vente'):true;
        axios.get(`${base_url}/users`,{
                headers:{
                    Accept:'application/json',
                    'Content-Type':'application/json;charset=UTF-8',
                    Authorization:`Bearer ${this.accessToken}`
                }
            })
              .then((response)=>{
                    console.log(response.data);
                  if(response.status==200){
                      this.users = response.data.users
                  }                
              })
              .catch((error)=>{
                  if(error?.response?.status === 403){
                    console.log('NO access');
                    $('#openModalNoAccess').trigger('click');
                }
                else {
                // Gérer d'autres erreurs ici
                console.log('Une erreur est survenue!');
                console.log('Autre erreur:', error);
                }
                  console.error(error);
              });
    },
    methods:{
        formatDate(dateString) {
              const date = new Date(dateString);
              const day = ('0' + date.getDate()).slice(-2);
              const month = ('0' + (date.getMonth() + 1)).slice(-2);
              const year = date.getFullYear();
              const hours = ('0' + date.getHours()).slice(-2);
              const minutes = ('0' + date.getMinutes()).slice(-2);
              const seconds = ('0' + date.getSeconds()).slice(-2);
  
              return `${day}-${month}-${year}`;
        },
        getInfoUser(code){
                // console.log(code);
                // return false;
                this.info_user=[];
                axios.get(`${base_url}/infoUser?code=${code}`,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    console.log('DAta');
                    
                    console.log(response.data.user);
                    const info = response.data.user;
                    this.updateModalContent(info);
                })
                .catch((error)=>{
                    if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#closeVoirDetailsUser').trigger('click');
                        $('#openModalNoAccess').trigger('click');
                    }
                    else {
                    // Gérer d'autres erreurs ici
                    console.log('Une erreur est survenue!');
                    console.log('Autre erreur:', error);
                    }
                })
        },
        updateModalContent(donnee){
            this.info_user=donnee;
        },
        updateModalEdit(donnee){
            this.editUser=donnee;
            this.form_update.nom=this.editUser.nom_user;
            this.form_update.prenom=this.editUser.prenom_user;
            this.form_update.email=this.editUser.email_user;
            this.form_update.phone=this.editUser.phone_user;
            this.form_update.user=this.editUser.utilisateur;
        },
        updateModalReset(donnee){
            this.resetpUser=donnee;
        },
        editInfoUser(code){
                this.editUser=[];
                axios.get(`${base_url}/infoUser?code=${code}`,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    console.log('Edit');
                    // console.log(response.data);
                    const info = response.data.user;
                    this.updateModalEdit(info);
                })
                .catch((error)=>{
                    if(error?.response?.status === 403){
                        // this.$router.push('/no-access');
                        console.log('NO access');
                        $('#closeModifierUser').trigger('click');
                        $('#openModalNoAccess').trigger('click');
                    }
                    else {
                    // Gérer d'autres erreurs ici
                    console.log('Une erreur est survenue!');
                    console.log('Autre erreur:', error);
                    }
                })
        },
        resetUser(code){
                this.resetpUser=[];
                this.passwordReset='';
                axios.get(`${base_url}/infoUser?code=${code}`,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    console.log('Reset Password');
                    console.log(response.data.user);
                    const info = response.data.user;
                    this.updateModalReset(info);
                })
                .catch((error)=>{
                    if(error?.response?.status === 403){
                        // this.$router.push('/no-access');
                        console.log('NO access');
                        $('#closeResetPasswordUser').trigger('click');
                        $('#openModalNoAccess').trigger('click');
                    }
                    else {
                    // Gérer d'autres erreurs ici
                    console.log('Une erreur est survenue!');
                    console.log('Autre erreur:', error);
                    }
                })
        },
        resetPassword(email){
            // console.log(email);
            // return false;
            axios.get(`${base_url}/resetpassword?mail=${email}`,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    // console.log(response.data);
                    // console.log(response.data.Code);
                    if(response.data.Code){
                        this.passwordReset=response.data.Code;
                    }
                })
                .catch((error)=>{
                    if(error?.response?.status === 403){
                        // this.$router.push('/no-access');
                        console.log('NO access');
                        $('#closeResetPasswordUser').trigger('click');
                        $('#openModalNoAccess').trigger('click');
                    }
                    else {
                    // Gérer d'autres erreurs ici
                    console.log('Une erreur est survenue!');
                    console.log('Autre erreur:', error);
                    }
                })
        },
        textCopy() {
            // Get the password from the input text field
            const copyText = document.getElementById("pass");

            // Select the text field
            copyText.select();

            // For mobile devices
            copyText.setSelectionRange(0, 99999);

            // Copy the text inside the text field
            document.execCommand("copy");

            // afficher toast notification
            const toast = document.getElementById("toast");
            toast.style.visibility = "visible";

            // Hide toast apres 3 secondes
            setTimeout(() => {
                toast.style.visibility = "hidden";
            }, 3000);
        },
        updateUser(){
            console.log('ok');
            this.success_msg='';
            const control = !!(this.form_update.nom && this.form_update.prenom && this.form_update.email && this.form_update.phone);
            console.log(control);
            if(control){
                    const $data ={
                        id:this.form_update.user,
                        nom : this.form_update.nom,
                        prenom : this.form_update.prenom,
                        mail : this.form_update.email,
                        telephone: this.form_update.phone
                    };
                // console.log($data);
                // return false;
                axios.put(`${base_url}/updateUser`,$data,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    // console.log(response.data);
                    if(response.status==200|| response.status==201){
                        this.success_msg = `Utilisateur modifié avec success!`;
                        setTimeout(function() {
                            location.reload();
                        },200);
                    }
                    else{
                        console.log('Erreur!!!');
                    }
                })
                .catch((error)=>{
                    console.log(error);
                    if (error?.response?.status === 401) {
                            const error_msg = error.response.data.errors;
                            this.displayValidationErrors(error.response.data.errors);                       
                    } 
                    else if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#closeModalUpdated').trigger('click');
                        $('#openModalNoAccess').trigger('click');
                    }
                    else {
                    // Gérer d'autres erreurs ici
                    console.log('Autre erreur:', error);
                    }
                })
            }        
        },
        displayValidationErrors(errors) {
            this.validationErrors = [];

            // Parcourir les erreurs et les ajouter au tableau
            Object.keys(errors).forEach(field => {
                this.validationErrors.push(errors[field][0]);
            });

            // 5 secondes avant de vider les erreurs
            setTimeout(() => {
                this.clearValidationErrors();
            }, 5000);

        },
        clearValidationErrors() {
            this.validationErrors = [];
        }
  },
}
</script>
<style>
 .fa-passwd-reset > .fa-lock {font-size: 0.45rem;}
 .fa-passwd-resets > .fa-lock {font-size: 0.85rem;}
 #toast {
        visibility: hidden;
        background: #00C853;
        border-radius: 2px;
        position: fixed;
        color: #fff;
        text-align: center;
        left: 50%;
        min-width: 250px;
        margin-left: -140px;
        bottom: 30px;
        padding: 16px;
        padding-left: 32px;
    }

    #toast.show {
        visibility: visible;
        -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
        animation: fadein 0.5s, fadeout 0.5s 2.5s;
    }
</style>